import React from "react";
import "../../../css/Praplanning/ParaplanningFields.css";

const ParaplanningToggle = ({
  label = "Status",
  leftLabel = "In Progress",
  rightLabel = "Case Completed",
  checked,
  onChange,
}) => {
  return (
    <div className="ParaplanningToggleField">
      <span className="ParaplanningToggleField__Label FP_Body">{label}</span>

      <div className="ParaplanningToggleField__Wrap">
        <span>{leftLabel}</span>

        <label className="ParaplanningSwitch">
          <input
            type="checkbox"
            checked={checked}
            onChange={(event) => onChange(event.target.checked)}
          />
          <span />
        </label>

        <span>{rightLabel}</span>
      </div>
    </div>
  );
};

export default ParaplanningToggle;
